(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["affiliate-program"] && !Shopify.designMode) return;
  try {
    
// Buttons link directly to the UpPromote URL from section settings; no JS required.

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initCarousel(root) {
      if (!root || !root.classList.contains('merch-carousel')) return;
      if (root._merchCarousel && typeof root._merchCarousel.destroy === 'function') {
        root._merchCarousel.destroy();
      }

      var track = root.querySelector('.merch-carousel__track');
      var prev = root.querySelector('.merch-carousel__nav--prev');
      var next = root.querySelector('.merch-carousel__nav--next');
      if (!track) return;

      var count = parseInt(root.getAttribute('data-count'), 10) || 0;
      if (!count) return;

      var index = count;
      var step = 0;
      var animating = false;
      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var auto = root.getAttribute('data-auto') === 'true' && !reduce;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 4000;
      var dir = root.getAttribute('data-direction') === 'right' ? -1 : 1;
      var timer = null;

      function measure() {
        var card = track.querySelector('.merch-carousel__card');
        if (!card) return;
        var styles = window.getComputedStyle(track);
        var gap = parseFloat(styles.columnGap || styles.gap) || 16;
        step = card.getBoundingClientRect().width + gap;
      }

      function setX(i, animate) {
        track.style.transition = animate && !reduce ? 'transform 0.5s cubic-bezier(.22,.61,.36,1)' : 'none';
        track.style.transform = 'translate3d(' + (-i * step) + 'px,0,0)';
        index = i;
      }

      function jumpIfNeeded() {
        animating = false;
        if (index >= count * 2) setX(index - count, false);
        if (index < count) setX(index + count, false);
      }

      function go(delta) {
        if (animating && !reduce) return;
        animating = true;
        setX(index + delta, true);
        restart();
      }

      function restart() {
        if (!auto) return;
        if (timer) clearInterval(timer);
        timer = setInterval(function () { go(dir); }, interval);
      }

      function onTransitionEnd(event) {
        if (event.target === track) jumpIfNeeded();
      }
      function onNext() { go(1); }
      function onPrev() { go(-1); }
      function onResize() {
        measure();
        setX(index, false);
      }

      track.addEventListener('transitionend', onTransitionEnd);
      if (next) next.addEventListener('click', onNext);
      if (prev) prev.addEventListener('click', onPrev);
      window.addEventListener('resize', onResize);

      measure();
      setX(index, false);
      restart();

      root._merchCarousel = {
        destroy: function () {
          if (timer) clearInterval(timer);
          track.removeEventListener('transitionend', onTransitionEnd);
          if (next) next.removeEventListener('click', onNext);
          if (prev) prev.removeEventListener('click', onPrev);
          window.removeEventListener('resize', onResize);
        }
      };
    }

    function initAll() {
      document.querySelectorAll('.merch-carousel').forEach(initCarousel);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.merch-carousel') || event.target;
      initCarousel(root);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function isStudioFill(r, g, b) {
      var max = r > g ? (r > b ? r : b) : (g > b ? g : b);
      var min = r < g ? (r < b ? r : b) : (g < b ? g : b);
      var sat = max - min;
      var lum = 0.2126 * r + 0.7152 * g + 0.0722 * b;
      if (lum > 236 && sat < 24) return true;
      if (lum > 210 && sat < 18) return true;
      return false;
    }

    function isShadowOrReflection(r, g, b) {
      var max = r > g ? (r > b ? r : b) : (g > b ? g : b);
      var min = r < g ? (r < b ? r : b) : (g < b ? g : b);
      var sat = max - min;
      var lum = 0.2126 * r + 0.7152 * g + 0.0722 * b;
      if (lum > 168 && sat < 16) return true;
      if (lum > 188 && sat < 34 && b >= g - 4 && b >= r - 4) return true;
      return false;
    }

    function knockoutAndCrop(img) {
      if (!img || img.dataset.knocked === 'true') return;
      if (!img.complete || !img.naturalWidth) return;

      try {
        var w = img.naturalWidth;
        var h = img.naturalHeight;
        var canvas = document.createElement('canvas');
        canvas.width = w;
        canvas.height = h;
        var ctx = canvas.getContext('2d', { willReadFrequently: true });
        ctx.drawImage(img, 0, 0);
        var data = ctx.getImageData(0, 0, w, h);
        var px = data.data;
        var seen = new Uint8Array(w * h);
        var queue = [];

        function enqueue(x, y) {
          if (x < 0 || y < 0 || x >= w || y >= h) return;
          var p = y * w + x;
          if (seen[p]) return;
          var i = p * 4;
          if (isStudioFill(px[i], px[i + 1], px[i + 2]) || isShadowOrReflection(px[i], px[i + 1], px[i + 2])) {
            seen[p] = 1;
            queue.push(p);
          }
        }

        for (var x = 0; x < w; x++) { enqueue(x, 0); enqueue(x, h - 1); }
        for (var y = 0; y < h; y++) { enqueue(0, y); enqueue(w - 1, y); }

        while (queue.length) {
          var p = queue.pop();
          px[p * 4 + 3] = 0;
          var cx = p % w;
          var cy = (p - cx) / w;
          enqueue(cx + 1, cy);
          enqueue(cx - 1, cy);
          enqueue(cx, cy + 1);
          enqueue(cx, cy - 1);
        }

        var minX = w, minY = h, maxX = 0, maxY = 0;
        for (var p2 = 0; p2 < w * h; p2++) {
          if (px[p2 * 4 + 3] < 18) continue;
          var sx = p2 % w;
          var sy = (p2 - sx) / w;
          if (sx < minX) minX = sx;
          if (sy < minY) minY = sy;
          if (sx > maxX) maxX = sx;
          if (sy > maxY) maxY = sy;
        }

        ctx.putImageData(data, 0, 0);
        img.dataset.knocked = 'true';

        if (maxX > minX && maxY > minY) {
          var padX = Math.round((maxX - minX) * 0.04);
          var padY = Math.round((maxY - minY) * 0.04);
          minX = Math.max(0, minX - padX);
          minY = Math.max(0, minY - padY);
          maxX = Math.min(w - 1, maxX + padX);
          maxY = Math.min(h - 1, maxY + padY);
          var cw = maxX - minX + 1;
          var ch = maxY - minY + 1;
          var cut = document.createElement('canvas');
          cut.width = cw;
          cut.height = ch;
          cut.getContext('2d').drawImage(canvas, minX, minY, cw, ch, 0, 0, cw, ch);
          img.src = cut.toDataURL('image/png');
        } else {
          img.src = canvas.toDataURL('image/png');
        }
        img.classList.remove('is-blend');
      } catch (err) {
        img.classList.add('is-blend');
        img.dataset.knocked = 'true';
      }
    }

    function initHero(root) {
      if (!root || !root.classList.contains('merch-hero')) return;
      if (root._merchHero && typeof root._merchHero.destroy === 'function') root._merchHero.destroy();

      var slides = Array.prototype.slice.call(root.querySelectorAll('.merch-hero__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.merch-hero__dot'));
      var cta = root.querySelector('.merch-hero__cta');
      if (!slides.length) return;

      var knockout = root.getAttribute('data-knockout') === 'true';
      root.querySelectorAll('.merch-hero__img').forEach(function (img) {
        if (!knockout) return;
        if (img.complete) knockoutAndCrop(img);
        else img.addEventListener('load', function () { knockoutAndCrop(img); }, { once: true });
      });

      var index = 0;
      slides.forEach(function (slide, i) {
        if (slide.classList.contains('is-active')) index = i;
      });

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var auto = root.getAttribute('data-auto') === 'true' && !reduce && slides.length > 1;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      var timer = null;

      function syncButton(slide) {
        if (!cta) return;
        var url = (slide.getAttribute('data-url') || '').trim();
        if (url) {
          cta.setAttribute('href', url);
          cta.classList.remove('is-disabled');
          cta.setAttribute('aria-disabled', 'false');
        } else {
          cta.setAttribute('href', '#');
          cta.classList.add('is-disabled');
          cta.setAttribute('aria-disabled', 'true');
        }
      }

      function show(nextIndex) {
        var total = slides.length;
        nextIndex = ((nextIndex % total) + total) % total;
        slides.forEach(function (slide, i) { slide.classList.toggle('is-active', i === nextIndex); });
        dots.forEach(function (dot, i) { dot.classList.toggle('is-active', i === nextIndex); });
        index = nextIndex;
        syncButton(slides[index]);
        restart();
      }

      function restart() {
        if (!auto) return;
        if (timer) clearInterval(timer);
        timer = setInterval(function () { show(index + 1); }, interval);
      }
      function onDot(event) {
        var to = parseInt(event.currentTarget.getAttribute('data-goto'), 10);
        if (!isNaN(to)) show(to);
      }

      dots.forEach(function (dot) { dot.addEventListener('click', onDot); });
      syncButton(slides[index]);
      restart();

      root._merchHero = {
        destroy: function () {
          if (timer) clearInterval(timer);
          dots.forEach(function (dot) { dot.removeEventListener('click', onDot); });
        }
      };
    }

    function initAll() {
      document.querySelectorAll('.merch-hero').forEach(initHero);
    }

    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
    else initAll();

    document.addEventListener('shopify:section:load', function (event) {
      initHero(event.target.querySelector('.merch-hero') || event.target);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["merch-slideshow"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initSlideshow(root) {
      if (!root || !root.classList.contains('merch-ss')) return;
      if (root._merchSS && typeof root._merchSS.destroy === 'function') root._merchSS.destroy();

      var slides = Array.prototype.slice.call(root.querySelectorAll('.merch-ss__slide'));
      var dots = Array.prototype.slice.call(root.querySelectorAll('.merch-ss__dot'));
      var prev = root.querySelector('.merch-ss__nav--prev');
      var next = root.querySelector('.merch-ss__nav--next');
      var cta = root.querySelector('.merch-ss__cta');
      if (!slides.length) return;

      var index = 0;
      slides.forEach(function (slide, i) {
        if (slide.classList.contains('is-active')) index = i;
      });

      var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      var auto = root.getAttribute('data-auto') === 'true' && !reduce && slides.length > 1;
      var interval = parseInt(root.getAttribute('data-interval'), 10) || 5000;
      var timer = null;

      function syncButton(slide) {
        if (!cta) return;
        var url = (slide.getAttribute('data-url') || '').trim();
        var label = (slide.getAttribute('data-label') || '').trim();
        if (label) cta.textContent = label;
        if (url) {
          cta.setAttribute('href', url);
          cta.classList.remove('is-disabled');
          cta.setAttribute('aria-disabled', 'false');
        } else {
          cta.setAttribute('href', '#');
          cta.classList.add('is-disabled');
          cta.setAttribute('aria-disabled', 'true');
        }
      }

      function show(nextIndex) {
        var total = slides.length;
        nextIndex = ((nextIndex % total) + total) % total;
        slides.forEach(function (slide, i) {
          slide.classList.toggle('is-active', i === nextIndex);
        });
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === nextIndex);
        });
        index = nextIndex;
        syncButton(slides[index]);
        restart();
      }

      function go(delta) { show(index + delta); }
      function restart() {
        if (!auto) return;
        if (timer) clearInterval(timer);
        timer = setInterval(function () { go(1); }, interval);
      }
      function onNext() { go(1); }
      function onPrev() { go(-1); }
      function onDot(event) {
        var to = parseInt(event.currentTarget.getAttribute('data-goto'), 10);
        if (!isNaN(to)) show(to);
      }

      if (next) next.addEventListener('click', onNext);
      if (prev) prev.addEventListener('click', onPrev);
      dots.forEach(function (dot) { dot.addEventListener('click', onDot); });

      syncButton(slides[index]);
      restart();

      root._merchSS = {
        destroy: function () {
          if (timer) clearInterval(timer);
          if (next) next.removeEventListener('click', onNext);
          if (prev) prev.removeEventListener('click', onPrev);
          dots.forEach(function (dot) { dot.removeEventListener('click', onDot); });
        }
      };
    }

    function initAll() {
      document.querySelectorAll('.merch-ss').forEach(initSlideshow);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var root = event.target.querySelector('.merch-ss') || event.target;
      initSlideshow(root);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
